"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _theme = _interopRequireDefault(require("../../theme"));
var _focus = require("../../styles/focus");
var _Icon = _interopRequireDefault(require("../../icons/Icon"));
var _typographyHelper = require("../../utils/typographyHelper");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var StyledButton = _styledComponents["default"].button.withConfig({
  displayName: "ButtonWithTooltip__StyledButton",
  componentId: "sc-1pj6q9w-0"
})(["display:inline-flex;flex-direction:", ";align-items:center;font-family:", ";font-size:", ";line-height:1.25;background:transparent;color:", ";border:none;gap:", ";padding:0;cursor:pointer;", ""], function (_ref) {
  var direction = _ref.direction;
  return direction === 'right' ? 'row' : 'row-reverse';
}, _theme["default"].buenosAires, (0, _typographyHelper.pxToRem)(16), function (_ref2) {
  var color = _ref2.color;
  return color;
}, _theme["default"].space10, _focus.focusStylesWithRoundedEdges);
var getColor = function getColor(colorTheme, isHovered) {
  if (colorTheme === 'dark') {
    return isHovered ? _theme["default"].indigo80 : _theme["default"].indigo60;
  }
  return 'white';
};
var ButtonWithTooltip = function ButtonWithTooltip(_ref3) {
  var _ref3$colorTheme = _ref3.colorTheme,
    colorTheme = _ref3$colorTheme === void 0 ? 'dark' : _ref3$colorTheme,
    onClick = _ref3.onClick,
    text = _ref3.text,
    _ref3$direction = _ref3.direction,
    direction = _ref3$direction === void 0 ? 'right' : _ref3$direction;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  var toggleHover = function toggleHover(hoverState) {
    return setIsHovered(hoverState);
  };
  var color = getColor(colorTheme, isHovered);
  return /*#__PURE__*/_react["default"].createElement(StyledButton, {
    direction: direction,
    onMouseEnter: function onMouseEnter() {
      return toggleHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return toggleHover(false);
    },
    onFocus: function onFocus() {
      return toggleHover(true);
    },
    onBlur: function onBlur() {
      return toggleHover(false);
    },
    onClick: onClick,
    color: color
  }, text, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "tooltip",
    size: 24,
    color: color
  }));
};
ButtonWithTooltip.propTypes = {
  colorTheme: _propTypes["default"].oneOf(['light', 'dark']),
  direction: _propTypes["default"].oneOf(['left', 'right']),
  onClick: _propTypes["default"].func.isRequired,
  text: _propTypes["default"].string
};
var _default = exports["default"] = ButtonWithTooltip;